import { useSelector } from "@lanyi/mox";
import { formateAndExcelExport } from '@/lib/excel/excel.js';
import ParalleTask from '@/utils/paralleTask'
function keysObject (obj, fn) {
  Object.keys(obj).forEach(key => {
    fn(key)
  })
}
export const formTable = {
  setup() {
    const backStatus = useSelector("back.backClick");
    return {
      backStatus,
    }
  },
  data() {
    return {
      list: [], // 表格数组
      keys: {}, // 表头
      data: null, // 存一下，接口返回data
      loading: false,
      loadingCount: 0,
      allCount: 0, // 总条数
      pageCount: 0, // 总页数
      pageSize: 20, // 每页条数
      page: 1, // 当前页码
      excelAllLoading: false,
    }
  },
  created() {
    this.initForm() // 填充默认值
    if (!this.backStatus || !this.name) return
    const initDate = JSON.parse(localStorage.getItem(this.name));
    if (initDate) {
      this.page = initDate.page || 1
      this.pageSize = initDate.pageSize || 20
      this.form && keysObject(this.form, key => {
        this.$set(this.form, key, initDate[key] ?? this.form[key])
      })
      if (this.keepAlive) {
        this.keepAlive.forEach(key => {
          this[key] = initDate[key] ?? this[key]
        })
      }
    }
  },
  mounted() {
    if (this.stopMounted) return 
    this.onGetList();
  },
  methods: {
    initForm() {
      if (!this.form) this.form = {}
      let initObject = {}
      if (this.formOptions) {
        this.formOptions.forEach(item => {
          if (item.propStart) {
            // 时间格式
            initObject[item.propStart] = item.defaultStart
            initObject[item.propEnd] = item.defaultEnd
          } else {
            initObject[item.prop] = item.default
          }
        })
      }
      this.form = Object.assign(initObject, this.form)
    },
    async onGetList() {
      this.loading = true
      this.loadingCount++
      try {
        let params = {
          page: this.page,
          pageSize: this.pageSize,
        }
        if (this.noPage) {
          params.page = undefined
          params.pageSize = undefined
        }
        if (this.form) {
          Object.assign(params, this.form)
        }
        if (this.formatApiParams) {
          params = this.formatApiParams(params)
        }
        this.lastParams = params
        const { code, data } = await this.requestApi(params)
        if ( code !== 200) {
          throw new Error()
        }
        
        this.handleDefaultData(data)
        // 返回的缓存
        if (this.keepAlive) {
          this.keepAlive.forEach(key => {
            params[key] = this[key]
          })
        }
        this.name && localStorage.setItem(this.name, JSON.stringify(params));
        // 回到顶部
        document.getElementById('main').scrollTo(0,0)
      } catch (e) {
        this.handleDefaultData({
          keys: {},
          list: [],
          allCount: 0,
          pageSize: 20,
          pageCount: 0,
          page: 1
        })
      } finally {
        this.loading = false
        this.loadingCount--
      }
    },
    handleDefaultData (data) {
      this.data = data
      this.excelData = data
      this.list = data.list
      this.keys = data.keys
      if (!this.noPage) {
        this.allCount = data.allCount;
        this.pageCount = data.pageCount;
        this.pageSize = data.pageSize;
        this.page = data.page;
      }
    },
    onExcel (name) {
      formateAndExcelExport(
        this.excelData,
        this.page,
        this.pageCount,
        typeof(name) === 'string' ? name : `${this.$route.meta.title}数据报表`
      );
    },
    onPageChange(page) {
      this.page = page;
      this.onGetList()
    },
    onSearch() {
      this.onPageChange(1)
    },
    onReset () {
      this.form = this.$options.data().form
      this.initForm()
      // this.onSearch()
    },
    async onApiCatch ({
      api,
      params,
      onSuccess,
      onError,
      onFinally,
      loadingName,
      loadingThis = this,
      successMsg = '操作成功',
    }) {
      if (loadingName && loadingThis[loadingName]) return
      try {
        loadingName && (loadingThis[loadingName] = true)
        let { code, msg, data } = await api(params)
        if (code !== 200) {
          throw new Error(msg)
        }
        onSuccess && onSuccess(data)
        this.$message.success(successMsg)
      } catch(e) {
        onError && onError(e)
        this.$message.error(e.message || e)
      } finally {
        loadingName && ( loadingThis[loadingName] = false)
        onFinally && onFinally()
      }
    },
    onExcelAll() {
      let params = this.lastParams
      params.pageSize = 500
      let pageCount = Math.ceil(this.allCount / params.pageSize)
      const promiseArr = []
      for (let i = 1; i <= pageCount; i++) {
        params.page = i
        let newParmas = JSON.parse(JSON.stringify(params))
        promiseArr.push(() => {
          return this.requestApi(newParmas)
        })
      }
      this.excelAllLoading = true
      this.$message({
        showClose: true,
        message: '下载数据中，请勿刷新页面！',
        type: 'warning',
        duration: 0
      })
      ParalleTask(promiseArr, 8).then(res => {
        const keys = this.keys
        const allList = res.reduce((arr, cur) => arr.concat(cur?.data?.list || []), [])
        formateAndExcelExport(
          { keys, list: allList },
          1,
          1,
          `${this.$route.meta.title}数据报表`,
          undefined,
          `${this.$route.meta.title}数据报表, 共${this.allCount}条数据`,
          () => {
            this.excelAllLoading = false
            this.$message.closeAll()
          }
        );
      })
      .catch(err => {
        this.excelAllLoading = false
        this.$message.closeAll()
        this.$message.error(err.message || err || '网络错误，请稍后再试！')
      })
    },
  }
}